//----------PRODUCCION-------------
import ControlTiemposMuertos from "../../../views/administrador/Produccion/ControlTiemposMuertos";
import Liberar_lotes from "../../../views/administrador/Produccion/Liberar_lotes";
import Calculo_Resistencias from "../../../views/administrador/Produccion/Calculo_Resistencias";
import ValidarCalculo_Resistencias from "../../../views/administrador/Produccion/ValidarCalculo_Resistencias";
import CalculoGranulometria from "../../../views/administrador/Produccion/CalculoGranulometria";
import CertificadosCalidad from "../../../views/administrador/Produccion/CertificadosCalidad";
import CertificadosGenerados from "../../../views/administrador/Produccion/CertificadosGenerados";
import AdministrarCertificadosCalidad from "../../../views/administrador/Produccion/AdministrarCertificadosCalidad";


const routes_produccion = [
  {
    path: "/ControlTiemposMuertos",
    name: "Tiempos Muertos",
    icon: "",
    component: ControlTiemposMuertos,
    doNotShow: true,
  }, 
  {
    path: "/Liberar_lotes",
    name: "Liberar Lotes",
    icon: "",
    component: Liberar_lotes,
    doNotShow: true,
  }, 
  {
    path: "/Calculo_Resistencias",
    name: "Calculo de Resistencias",
    icon: "",
    component: Calculo_Resistencias,
    doNotShow: true,
  }, 
  {
    path: "/ValidarCalculo_Resistencias",
    name: "Validar Calculo Resistencias",
    icon: "",
    component: ValidarCalculo_Resistencias,
    doNotShow: true,
  },
  {
    path: "/CalculoGranulometria",
    name: "Calculo Granulometria",
    icon: "",
    component: CalculoGranulometria,
    doNotShow: true,
  },
  {
    path: "/CertificadosCalidad",
    name: "Certificados de Calidad",
    icon: "",
    component: CertificadosCalidad,
    doNotShow: true,
  },
  {
    path: "/CertificadosGenerados",
    name: "Buzon de Certificados",
    icon: "",
    component: CertificadosGenerados,
    doNotShow: true,
  },
  {
    path: "/AdministrarCertificadosCalidad",
    name: "Administrar Certificados de Calidad",
    icon: "",
    component: AdministrarCertificadosCalidad,
    doNotShow: true,
  },
];

export default routes_produccion;
